export const SYSTEM_ERROR = {
  UNKNOWN: 'システムで問題が発生しました。時間をおいて再度お試しください。',
  TIMEOUT: '接続がタイムアウトしました。時間をおいて再度お試しください。',
  422: 'ページの有効期限が切れています。ページを再読み込みしてください'
}
